import { render } from "./FbnReviewBusinessNames.vue?vue&type=template&id=2974eb9c"
import script from "./FbnReviewBusinessNames.vue?vue&type=script&lang=js"
export * from "./FbnReviewBusinessNames.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__